import api from "@/api";
import { get, post } from "@/utils/http";

const getAbsolutePathIfExists = (str) => {
  if (!str) return "";
  let arr;
  try {
    arr = JSON.parse(str);
  } catch (e) {
    // If it's not valid JSON, assume it might already be a URL or a string we can't parse
    return str;
  }
  if (Array.isArray(arr) && arr.length > 0) {
    // eslint-disable-next-line no-prototype-builtins
    const itemWithAbsolutePath = arr.find((item) => item.hasOwnProperty("absolutePath"));
    if (itemWithAbsolutePath) {
      return itemWithAbsolutePath.absolutePath;
    }
  }
  return str;
};

const getDisposition = async () => {
  localStorage.removeItem("uiInfo");
  // 获取登录所有配置，存到本地缓存 lingbomanager.linggekj.com window.location.hostname.toString()
  try {
   const res = await get(api.getAllUiInfo, { domainUrl: window.location.hostname.toString() });
    if (!res) {
      throw new Error("请求失败");
    }
    // eslint-disable-next-line no-underscore-dangle
    const _res = JSON.parse(JSON.stringify(res));
    // eslint-disable-next-line no-restricted-syntax
    for (const key in _res) {
      if (
        [
          "appHomeLogo",
          "appHomeLogoSmall",
          "appLoginLogo",
          "appHomeIcon",
          "appLoginBackPic",
        ].includes(key)
      ) {
        if (_res[key]) {
          // eslint-disable-next-line no-param-reassign
          _res[key] = getAbsolutePathIfExists(_res[key]);
        }
      }
    }
    // eslint-disable-next-line no-unused-expressions
    _res.appLoginTitle ? (document.title = _res.appLoginTitle) : null;
    localStorage.setItem("uiInfo", JSON.stringify(_res));
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("调试模式下请求无效", error);
    } else {
      console.error("初始化ui配置接口请求失败", error);
    }
  }
};

// 获取菜单页装修配置
const getUiFitment = async () => {
  localStorage.removeItem("ui_fitment");
  try {
    const res = await post(api.getUiApply, {});

    if (!res) {
      throw new Error("请求失败");
    }
    const _res = res.data || {};
    for (const key in _res) {
      // 菜单栏小LOGO menuLogoSmall
      // 浏览器ICO图 browserIco
      // 数据大屏LOGO dataDashboardLogo
      // 菜单栏LOGO menuLogo
      // 导航背景色 navigationBackColor
      // 主题色 themeColor
      if (["menuLogoSmall", "browserIco", "dataDashboardLogo", "menuLogo"].includes(key)) {
        if (_res[key]) {
          _res[key] = getAbsolutePathIfExists(_res[key]);
        }
      }
    }
    if (_res.homeTitle) {
      document.title = _res.homeTitle;
    }
    console.log(_res);
    localStorage.setItem("ui_fitment", JSON.stringify(_res));
  } catch (error) {
    console.error("初始化主页装修配置接口请求失败", error);
  }
};
// eslint-disable-next-line import/prefer-default-export
export { getDisposition, getUiFitment };
